var map = {
	"./basic.svg": "e822",
	"./decoration-basic-mini.svg": "8dd6",
	"./decoration-basic.svg": "3645f",
	"./decoration-diamond-mini.svg": "e224",
	"./decoration-diamond.svg": "e99a",
	"./decoration-gold-mini.svg": "53b2",
	"./decoration-gold.svg": "5305",
	"./decoration-platinum-mini.svg": "80d0",
	"./decoration-platinum.svg": "6ca5",
	"./decoration-silver-mini.svg": "3ab1",
	"./decoration-silver.svg": "2b3d",
	"./diamond.svg": "4fc0",
	"./eye-close.svg": "eb2f",
	"./eye-open.svg": "ab4e",
	"./gold.svg": "00f6",
	"./platinum.svg": "8149",
	"./silver.svg": "afb4"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e8c5";